import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';

export class MedicalRecordPractitionerModel extends WithPermissionModel{
    id: number;
    partnerPractitioner: PartnerSummaryModel;
    partner: PartnerSummaryModel;
    doctor: boolean;
}
